import { render, staticRenderFns } from "./StepperBlock.vue?vue&type=template&id=023e878e&scoped=true"
import script from "./StepperBlock.vue?vue&type=script&lang=js"
export * from "./StepperBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023e878e",
  null
  
)

export default component.exports